import React from 'react';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import {
  reduxForm,
  Field,
  FieldArray,
  getFormValues,
  isDirty,
  change,
  arrayRemoveAll,
  arrayPush,
  initialize,
} from 'redux-form';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { connect } from 'react-redux';

// import * as clevertapItem from 'clevertap/inventory/item';
import * as actItem from 'actions/library/item';
import { isDisableOutletLevelForm } from 'utils/userProperties';
import UploadImage from 'components/Fields/ReduxForm/UploadImage';
import { Creatable } from 'react-select';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import * as clevertapLibraryList from 'clevertap/library/list';
import { Link } from 'react-router';
import validator from 'validator';
import ConfirmModal from 'components/ConfirmModal';
import ConfirmActionModal from 'components/ConfirmActionModal';
import Switch from 'components/Fields/ReduxForm/Switch';
import TooltipCommerceStore from 'components/TooltipCommerce';
import { askConfirmAction } from 'actions/confirm-action';
import { showUpgradeModal } from 'reducers/featureRestrictions/actions';
import withFeatureFlag from 'hocs/withFeatureFlags';
import styles from './ItemForm.css';
import 'react-select/dist/react-select.css';
import ItemVariant from './ItemVariant';
import ItemInventoryAlert from './ItemInventoryAlert';
import COGS from './COGS';
import ItemModifier from './ItemModifier';
import ItemVariantModal from './ItemVariantModal';
import SalesTypeModal from './SalesTypeModal';
import ItemInventoryAlertModal from './ItemInventoryAlertModal';
import COGSModal from './COGSModal';
import CreateCategoryModal from './CreateCategoryModal';
import SaveToAllOutletsModal from './SaveToAllOutletsModal';
import UpdateToAllOutletsModal from './UpdateToAllOutletsModal';
import ErrorUpdateAllOutletModal from './ErrorUpdateAllOutletModal';
import WarningLabel from './WarningLabel';
import GeneralInformation from './GeneralInformation';
import ProductAtrribute from './ProductAttribute';
import RewardAlert from '../../../RewardAlert';

const tooltipDeleteBtn = (
  <Popover id="popover-trigger-hover-focus">
    This item cannot be deleted because it has been associated with a Recipe.
    Please first delete the Recipe and try again.
  </Popover>
);

const tooltipBusinessDeleteBtn = (
  <Popover id="popover-trigger-hover-focus">
    This item cannot be deleted. Go to Business Library to delete
  </Popover>
);

const validate = (values, props) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }
  if (props.ecommerceAttributes && props.isRetail && values.is_ecommerce) {
    const dimension = {};

    if (values.brand_id === null || values.brand_id === 0) {
      errors.brand_id = "Brand can't be empty";
    }

    if (!values.weight.value) {
      errors.weight = {
        value: 'Please enter a value',
      };
    }
    if (values.dimension && !values.dimension.length)
      dimension.length = 'Please enter a value';
    if (values.dimension && !values.dimension.width)
      dimension.width = 'Please enter a value';
    if (values.dimension && !values.dimension.height)
      dimension.height = 'Please enter a value';
    errors.dimension = dimension;
  }

  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value';
  } else if (values.amount <= 0) {
    errors.amount = 'Please enter a value > 0';
  } else if (values.amount > 100 && values.typeAmount) {
    errors.amount = 'Please input Item amount less than 100%';
  } else if (values.amount > 100000000000 && !values.typeAmount) {
    errors.amount = 'Please input Item amount less than 100.000.000.000';
  }

  const itemVariantsErrors = [];
  if (values.item_variants) {
    values.item_variants.forEach((iv, index) => {
      const memberError = {};
      if (!iv.name && values.item_variants.length > 1) {
        memberError.name = 'Please fill in Variant Name';
      }
      if (!iv.in_stock && `${iv.in_stock}` !== '0') {
        memberError.in_stock = 'Stock is required';
      } else if (!validator.isNumeric(`${iv.in_stock}`)) {
        memberError.in_stock = 'Please enter a valid Number';
      } else if (
        props.hasImproveNineDigitStock === true &&
        iv.in_stock > 999999999
      ) {
        memberError.in_stock = 'In stock must be less than 9 digits';
      } else if (
        props.hasImproveNineDigitStock === false &&
        iv.in_stock > 999999
      ) {
        memberError.in_stock = 'In stock must be less than 6 digits';
      }
      if (iv.price > 99999999999) {
        memberError.price = 'Price must be less than 99.999.999.999';
      }
      if (!iv.cogs && `${iv.cogs}` !== '0') {
        memberError.cogs = 'Avg. cost is required';
      }
      if (iv.cogs > 99999999999) {
        memberError.cogs = 'Avg. Cost must be less than 11 digits';
      }
      if (values.is_sales_type_price && iv.sales_type_items) {
        memberError.sales_type_items = [];
        iv.sales_type_items.forEach((sti, index) => {
          memberError.sales_type_items[index] = {};
          if (sti.sales_type_price > 99999999999) {
            memberError.sales_type_items[index].sales_type_price =
              'Price must be less than 99.999.999.999';
          }
        });
      }
      if (Object.keys(memberError).length > 0) {
        itemVariantsErrors[index] = memberError;
      }
    });
  }
  if (itemVariantsErrors.length) {
    errors.item_variants = itemVariantsErrors;
  }

  return errors;
};

class RenderSelectField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectInstance: 1,
    };
  }

  onChangeSelect = newval => {
    const {
      input: { value, onChange },
      meta: { dispatch },
      options,
      categories,
    } = this.props;
    let isNewCategory = true;
    options.forEach(cat => {
      if (cat.value === newval.value && typeof newval.value === 'number') {
        isNewCategory = false;
      }
    });
    if (isNewCategory) {
      dispatch(
        actItem.onClickCreateNewCategory(newval.value, categories, value)
      );
      onChange(newval.value);
    } else {
      onChange(newval.value);
    }
  };

  render() {
    const {
      input: { value },
      placeholder,
      options,
      disabled,
    } = this.props;
    const selectProps = {
      addLabelText: '{label} (create new)',
      value,
      className: styles['select-dropdown'],
      placeholder,
      onChange: this.onChangeSelect,
      options,
      disabled,
      clearable: false,
      backspaceRemoves: false,
      promptTextCreator: label => `${label} (create new)`,
      onClose: () => {
        this.setState({ selectInstance: 1 - this.state.selectInstance });
      },
    };
    // TODO HACK buat nyamain behaviour kode lama:
    // harus dalam html tag yang beda
    // harus dua komponen yang beda
    if (this.state.selectInstance === 1) {
      return (
        <div>
          <Creatable {...selectProps} />
        </div>
      );
    }
    return (
      <span>
        <Creatable {...selectProps} />
      </span>
    );
  }
}

class ItemForm extends React.Component {
  constructor(props) {
    super(props);
    this.scrollArea = null;
  }

  _handleOnChange = () => {
    // previous value
    const { itemForm, dispatch, customCategoriesEcommerceFashion } = this.props;

    if (itemForm.is_product_attribute) {
      const itemVariantTempForm = itemForm.item_variants.filter(
        itemVariant => !itemVariant.is_generated
      );

      dispatch(arrayRemoveAll('item', 'item_variants'));

      customCategoriesEcommerceFashion.map(customCategoryEcommerce => {
        const { name } = customCategoryEcommerce;
        const labelName = name.charAt(0).toUpperCase() + name.slice(1);
        const actionType = `unsetCustomCategory${labelName}AllData`;
        dispatch(actItem[actionType]());
      });

      itemVariantTempForm.map(itemVariant =>
        dispatch(arrayPush('item', 'item_variants', itemVariant))
      );
    }
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.mustScrollTop) {
      this.scrollArea.scrollTop = 0;
    }
  }

  render() {
    const {
      businessLibraryMenu,
      itemDetail,
      handleSubmit,
      categories,
      modifiers,
      itemForm,
      showDeleteModal,
      showUpdateModal,
      isSubmittingForm,
      outlets,
      ingredientSubscriptionDetail,
      salesType,
      mokapayMode,
      allowLongerDescription,
      onUpgradeNowClick,
      isMokaposUser,
      ecommerceAttributes,
      showNewBrandModal,
      newBrand,
      isRetail,
      updateToAllOutlets,
      showUpdateToAllOutletsModal,
      showErrorUpdateAllOutletModal,
    } = this.props;
    const isDisableForm = isDisableOutletLevelForm(
      businessLibraryMenu,
      itemDetail
    );
    const uploadImagePlaceholder =
      itemForm && itemForm.name ? itemForm.name.substring(0, 2) : '';
    return (
      <form onSubmit={handleSubmit} className="full-height form-item">
        <div
          ref={a => {
            this.scrollArea = a;
          }}
          className={`${styles['item-fieldset']} body-form-item`}
        >
          {ecommerceAttributes && isRetail ? (
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <label
                    className={`${styles['label-input']} ${
                      styles['label-product']
                    }`}
                  >
                    GENERAL INFORMATION
                  </label>
                </div>
                <GeneralInformation
                  categories={categories}
                  uploadImagePlaceholder={uploadImagePlaceholder}
                  itemDetail={itemDetail}
                  isDisableForm={isDisableForm}
                />
              </div>
            </div>
          ) : (
            <div className="row">
              <Field component="input" type="hidden" name="id" />
              <div className="col-lg-3 col-md-3 col-sm-3 no-padding-right item-image-box">
                <Field
                  name="image.url"
                  component={UploadImage}
                  placeholder={uploadImagePlaceholder}
                  className={styles['upload-image']}
                  backgroundColor={
                    itemDetail ? itemDetail.background_color : null
                  }
                  disableEditAndDeleteButton={isDisableForm}
                  disableEditDeleteButtonFeature={isDisableForm}
                />
              </div>
              <div
                className={`col-lg-9 col-md-9 col-sm-9 no-padding-left no-padding-right ${
                  styles['side-image-wrapper']
                }`}
              >
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group">
                      <Field
                        component={SettingField}
                        className="form-control"
                        name="name"
                        maxLength="40"
                        placeholder="Item Name"
                        type="text"
                        dis={isDisableForm}
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12">
                    <div className={`form-group ${styles.categories}`}>
                      <Field
                        component={RenderSelectField}
                        className="selectCategories"
                        name="category_id"
                        disabled={!isMokaposUser || isDisableForm}
                        options={this._formatCategories(categories)}
                        categories={categories}
                        onChange={this._onChangeCategories}
                        placeholder="Select an option"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className={`row ${styles['margin-top-5']}`}>
            {itemDetail && (
              <div className="col-lg-12">
                {(itemDetail.is_reward_item ||
                  itemDetail.is_point_gain_item) && (
                  <RewardAlert
                    title="Loyalty Program Item"
                    content="Any changes you make to this item will affect your loyalty program"
                    type="info"
                  />
                )}
              </div>
            )}
          </div>

          {ecommerceAttributes && isRetail && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className={`col-lg-12`}>
                <div className={`row ${styles['label-input']} ml-0px`}>
                  <div className="col-lg-3 no-padding-right no-padding-left">
                    <label className={styles['label-product']}>
                      PRODUCT ATTRIBUTE
                    </label>
                  </div>
                  <div className="col-lg-6">
                    <TooltipCommerceStore
                      placement="top"
                      delay={200}
                      name={'item'}
                    >
                      <div className={styles['toggle-badge-recommend']}>
                        Mandatory For Online Store
                      </div>
                    </TooltipCommerceStore>
                  </div>
                  <div
                    className={`col-lg-3 ${styles['toggle-button-container']}`}
                  >
                    <Field
                      component={Switch}
                      onChange={this.onChangeIsEcommerce}
                      disabled={false}
                      name={`is_ecommerce`}
                      type="checkbox"
                    />
                  </div>
                </div>
                {itemForm.is_ecommerce && <ProductAtrribute />}
              </div>
            </div>
          )}
          <div className={`row ${styles['margin-top-30']}`}>
            <div className="col-lg-12">
              <div className="form-group" style={{ marginBottom: 0 }}>
                {ecommerceAttributes && isRetail ? (
                  <div className={`${styles['label-input-ecommerce']}`}>
                    <label className={styles['pricing-label']}> Pricing </label>
                    <TooltipCommerceStore
                      placement="top"
                      delay={200}
                      name={'price'}
                    >
                      <div className={styles['toggle-badge-recommend']}>
                        Mandatory For Online Store
                      </div>
                    </TooltipCommerceStore>
                  </div>
                ) : (
                  <label className={`${styles['label-input']}`}>Pricing</label>
                )}
                <div>
                  {this._isHaveSalesType() && (
                    <div
                      className={`${styles['apply-item-pricing']} ${
                        styles['basic-pricing']
                      }`}
                    >
                      <label>
                        <Field
                          component="input"
                          type="checkbox"
                          disabled={isDisableForm}
                          name="is_sales_type_price"
                          onChange={this._onChangeSalesType}
                        />
                        &nbsp;&nbsp; Apply multiple price per sales type
                      </label>
                    </div>
                  )}
                  <ItemVariant salesType={salesType} />
                </div>
              </div>
            </div>
          </div>
          {/* Pay users */}
          {mokapayMode && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className={`${styles['label-input']}`}>
                    Inventory
                  </label>
                  <div className="form-group">
                    <button
                      className="btn btn-primary btn-block disabled"
                      disabled={mokapayMode}
                    >
                      <i className="glyphicon glyphicon-lock" />
                      &nbsp;
                      <span>Start Tracking Item Inventory and Alerts</span>
                    </button>
                  </div>
                  <WarningLabel type="info" link>
                    You can track your item and get alert when they are running
                    out of stock with Inventory. Available only on Moka POS.{' '}
                    <a onClick={onUpgradeNowClick}>Upgrade now</a> to start
                    using.
                  </WarningLabel>
                </div>
              </div>
            </div>
          )}

          {mokapayMode && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className={`${styles['label-input']}`}>COGS</label>
                  <div className="form-group">
                    <button
                      className="btn btn-primary btn-block disabled"
                      disabled={mokapayMode}
                    >
                      <i className="glyphicon glyphicon-lock" />
                      &nbsp;
                      <span>Start Tracking Cost of Goods Sold (COGS)</span>
                    </button>
                  </div>
                  <WarningLabel type="info" link>
                    You can track your cost of sales and know your company's
                    profit. Available only on Moka POS.{' '}
                    <a onClick={onUpgradeNowClick}>Upgrade now</a> to start
                    using.
                  </WarningLabel>
                </div>
              </div>
            </div>
          )}

          {/* Normal users */}
          {!mokapayMode && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className="col-lg-12">
                {itemDetail && (
                  <div className="form-group">
                    <label className={`${styles['label-input']}`}>
                      Inventory
                    </label>
                    <ItemInventoryAlert
                      disabled={
                        itemDetail.is_recipe &&
                        ingredientSubscriptionDetail.is_active
                      }
                      classButton={`${styles['disabled-button']}`}
                    />
                    {!(
                      itemDetail.is_recipe &&
                      ingredientSubscriptionDetail.is_active
                    ) && (
                      <WarningLabel
                        content="Item stock can not be changed after saving the item, so please make sure that it is correct!"
                        type="info"
                      />
                    )}
                    {itemDetail.is_recipe &&
                      ingredientSubscriptionDetail.is_active && (
                        <WarningLabel type="warning" link>
                          This item can not be tracked because it has a recipe.
                          Use the{' '}
                          <Link to="/ingredient/recipes">
                            <i>Ingredient Page</i>
                          </Link>{' '}
                          to manage recipes.
                        </WarningLabel>
                      )}
                  </div>
                )}
              </div>
            </div>
          )}
          {!mokapayMode && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className={`${styles['label-input']}`}>Cost</label>
                  {itemDetail && (
                    <COGS
                      disabled={
                        itemDetail.is_recipe &&
                        ingredientSubscriptionDetail.is_active
                      }
                      classButton={`${styles['disabled-button']}`}
                    />
                  )}
                </div>
              </div>
            </div>
          )}

          {/* All users */}
          {!mokapayMode && modifiers.length > 0 && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className={`${styles['label-input']}`}>Modifier</label>
                  <FieldArray
                    name="active_modifiers"
                    component={ItemModifier}
                    modifiers={modifiers}
                    disabled={isDisableForm}
                  />
                </div>
              </div>
            </div>
          )}
          {!isRetail && (
            <div className={`row ${styles['margin-top-30']}`}>
              <div className="col-lg-12">
                <div className="form-group">
                  <label className={`${styles['label-input']}`}>
                    Description
                  </label>
                  <Field
                    component="textarea"
                    className="form-control"
                    placeholder="Item Description"
                    maxLength={allowLongerDescription ? 255 : 70}
                    disabled={isDisableForm}
                    name="description"
                    type="text"
                    rows="3"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={`${styles.footer} footer-form-item`}>
          {itemDetail && itemDetail.id && (
            <span className="pull-left">{this.renderDeleteButton()}</span>
          )}
          <span className="pull-right">
            <button
              className="btn btn-default no-outline"
              type="button"
              style={{ 'margin-right': '10px' }}
              onClick={this._onClickCancel}
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            {itemForm && !itemForm.id && outlets && outlets.length > 1 && (
              <button
                className="btn btn-primary no-outline"
                type="button"
                style={{ 'margin-right': '10px' }}
                onClick={handleSubmit(this._onSubmitCreateAllOutlet)}
                disabled={isSubmittingForm}
              >
                Save to All Outlets
              </button>
            )}
            {updateToAllOutlets &&
              itemDetail &&
              itemDetail.id &&
              outlets &&
              outlets.length > 1 && (
                <button
                  className="btn btn-primary no-outline mr-10px"
                  type="submit"
                  onClick={this.onClickUpdateToAllOutlets}
                  disabled={isSubmittingForm}
                >
                  Update to All Outlets
                </button>
              )}
            <button
              className="btn btn-primary no-outline"
              type="submit"
              onClick={handleSubmit(this._onClickSave)}
              disabled={isSubmittingForm}
            >
              Save
            </button>
          </span>
        </div>
        <ItemVariantModal onSubmit={this._onSaveVariant} />
        <SalesTypeModal onSubmit={this._onSaveSalesType} />
        <ItemInventoryAlertModal onSubmit={this._onSaveTrackInv} />
        <SaveToAllOutletsModal
          itemName={itemDetail && itemDetail.name ? itemDetail.name : ''}
        />
        <ErrorUpdateAllOutletModal
          show={showErrorUpdateAllOutletModal}
          onConfirmModal={this.onConfirmModalErrorUpdateAllOutlet}
        />
        <COGSModal onSubmit={this._onSaveCOGS} />
        {itemDetail &&
          itemDetail.id &&
          !itemDetail.is_reward_item &&
          !itemDetail.is_point_gain_item &&
          !itemDetail.is_point_gain_category_item &&
          !itemDetail.is_reward_category_item && (
            <LibraryDeleteModal
              name={itemDetail.name}
              onHide={this._onHideDeleteModal}
              showDeleteModal={showDeleteModal}
              title="Item"
              onDelete={this._confirmDelete}
            />
          )}
        {itemDetail &&
          itemDetail.id &&
          (itemDetail.is_reward_item ||
            itemDetail.is_point_gain_item ||
            itemDetail.is_point_gain_category_item ||
            itemDetail.is_reward_category_item) && (
            <LibraryDeleteModal
              name={itemDetail.name}
              onHide={this._onHideDeleteModal}
              showDeleteModal={showDeleteModal}
              title="Loyalty Program Item"
              description="You can’t use this item in your loyalty program if you delete it. Are you sure you still want to delete?"
              onDelete={this._confirmDelete}
            />
          )}
        {itemDetail &&
          itemDetail.id &&
          (itemDetail.is_reward_item ||
            itemDetail.is_point_gain_item ||
            itemDetail.is_point_gain_category_item ||
            itemDetail.is_reward_category_item) && (
            <ConfirmModal
              name={itemDetail.name}
              onHide={this._onHideUpdateModal}
              showModal={showUpdateModal}
              title={
                itemDetail.categoryChangeTitle
                  ? itemDetail.categoryChangeTitle
                  : `Edit Loyalty Program Item`
              }
              description={
                itemDetail.categoryChangeMessage
                  ? itemDetail.categoryChangeMessage
                  : `You can’t use this item in your loyalty program if you change the item or variant names. Are you sure you still want to edit?`
              }
              onConfirm={handleSubmit(this._onSubmitSave)}
              baseColor="danger"
              cancelTitle="No"
              confirmTitle="Yes"
            />
          )}
        <CreateCategoryModal
          dispatch={this.props.dispatch}
          newCategory={this.props.newCategory}
          show={this.props.showNewCategoryModal}
          onCancel={this._onCancelCreateCategoryModal}
          onConfirm={this._onConfirmCreateCategoryModal}
        />
        <UpdateToAllOutletsModal
          show={showUpdateToAllOutletsModal}
          itemName={itemForm.name}
          onCancel={this.onCancelUpdateToAllOutletsModal}
          onConfirm={handleSubmit(this.onSubmitUpdateToAllOutlets)}
        />
        <CreateCategoryModal
          newCategory={newBrand}
          show={showNewBrandModal}
          onCancel={this.onCancelCreateNewBrand}
          onConfirm={this.onConfirmCreateBrandModal}
        />
        <ConfirmActionModal />
      </form>
    );
  }

  renderDeleteButton = () => {
    const {
      itemDetail,
      businessLibraryMenu,
      ingredientSubscriptionDetail,
      isSubmittingForm,
    } = this.props;

    const isDisableForm = isDisableOutletLevelForm(
      businessLibraryMenu,
      itemDetail
    );

    if (isDisableForm) {
      return (
        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="top"
          overlay={tooltipBusinessDeleteBtn}
        >
          <button
            className={`btn ${styles['disabled-button']}`}
            onClick={e => e.preventDefault()}
          >
            <i className="fa fa-trash" />
          </button>
        </OverlayTrigger>
      );
    }

    if (
      itemDetail &&
      (!itemDetail.is_recipe || !ingredientSubscriptionDetail.is_active)
    ) {
      return (
        <button
          className="btn btn-danger no-outline"
          onClick={this._onClickDelete}
          disabled={isSubmittingForm}
        >
          <i className="fa fa-trash" />
        </button>
      );
    }

    return (
      <OverlayTrigger
        trigger={['hover', 'focus']}
        placement="top"
        overlay={tooltipDeleteBtn}
      >
        <button
          className={`btn ${styles['disabled-button']}`}
          onClick={e => e.preventDefault()}
        >
          <i className="fa fa-trash" />
        </button>
      </OverlayTrigger>
    );
  };

  _onSaveVariant = value => {
    const { dispatch, isDirtyForm } = this.props;
    if (isDirtyForm) {
      dispatch(actItem.onConfirmItemVariantModal(value));
    } else {
      dispatch(actItem.onCancelItemVariantModal());
    }
  };

  onChangeIsEcommerce = event => {
    const { dispatch, itemForm, ecommerceCategory } = this.props;
    const isClothing = ecommerceCategory.google_category_id === 166;

    if (!itemForm.id && event.target.value) {
      // clevertapItem.inventoryItemEcommerceToggle(true);
      if (isClothing) {
        itemForm.age.value = 'All Ages';
        itemForm.gender.value = 'Unisex';
      }
      itemForm.condition = 'New';
      itemForm.weight = {
        unit: 'Gram (gr)',
        valueUniversal: 1,
        value: '',
      };
      itemForm.dimension = {
        length: '',
        width: '',
        height: '',
        unit: 'Centimeter (cm)',
        valueUniversal: 1,
      };
      itemForm.brand_id = null;
      dispatch(initialize('item', { ...itemForm }));
    } else {
      // clevertapItem.inventoryItemEcommerceToggle(true);
    }

    if (isClothing && event.target.value) {
      itemForm.item_variants = itemForm.item_variants.filter(
        iv => !iv.is_generated
      );
      if (itemForm.item_variants.length === 0) {
        const initialValue = {
          name: '',
          price: null,
          sku: '',
          in_stock: 0,
          stock_alert: 0,
          cogs: null,
          saved_cogs: false,
          is_saved: false,
          is_editable: true,
          is_new: true,
        };
        itemForm.item_variants = [initialValue];
      }
      dispatch(initialize('item', { ...itemForm }));
    }
  };

  _onSaveSalesType = value => {
    const { dispatch } = this.props;

    dispatch(actItem.onConfirmSalesTypeModal(value));
  };

  _onSaveTrackInv = value => {
    const { dispatch, itemForm, isDirtyForm } = this.props;
    let isTrack = false;
    itemForm.item_variants.forEach(iv => {
      if (iv.track_stock) {
        isTrack = true;
      }
    });
    // HACKY CODE
    // ini hack untuk yang FD-1471, karena validasi form entah hilang ketika melakukan remove array dan push kembali array yang kemungkinan sama
    // karena redux form tidak melakukan validasi kembali ketika proses push array baru berlangsung, untuk mengatasi keterbatasan itu,
    // maka dibuatlah logic:
    // jika tidak memberikan perubahan apa apa terhadap form maka tidak usah melakukan rangkaian confirm, cucup tutup modal saja
    if (isDirtyForm || !isTrack) {
      dispatch(actItem.onConfirmItemInventoryAlertModal(value, itemForm));
    } else {
      dispatch(actItem.onCancelItemInventoryAlertModal());
    }
  };

  _onSaveCOGS = value => {
    const { dispatch, isTrack, isDirtyForm } = this.props;
    if (isDirtyForm || !isTrack) {
      dispatch(actItem.onConfirmCOGSModal(value, isTrack));
    } else {
      dispatch(actItem.onCancelCOGSModal());
    }
  };

  _onCancelCreateCategoryModal = () => {
    const { dispatch, previousCategories, previousCategoryId } = this.props;
    dispatch(
      actItem.onCancelCreateNewCategory(previousCategories, previousCategoryId)
    );
  };

  _onConfirmCreateCategoryModal = () => {
    const { dispatch, newCategory } = this.props;
    dispatch(actItem.onConfirmCreateNewCategory(newCategory));
  };

  _onHideDeleteModal = () => {
    const { dispatch } = this.props;
    dispatch(actItem.hideDeleteModal());
  };

  _onHideUpdateModal = () => {
    const { dispatch } = this.props;
    dispatch(actItem.hideUpdateModal());
  };

  _confirmDelete = () => {
    const { dispatch, itemDetail, items, search } = this.props;
    clevertapLibraryList.libraryItemDelete({ item: itemDetail });
    dispatch(actItem.deleteItem(itemDetail, items, search));
  };

  _formatCategories = categories => {
    const formatCategory = [];
    categories.map(function(category) {
      if (category.id > 0) {
        formatCategory.push({ value: category.id, label: category.name });
      }
    });
    return formatCategory;
  };

  _onClickDelete = e => {
    const { dispatch } = this.props;
    dispatch(actItem.showDeleteModal());
    e.preventDefault();
    e.stopPropagation();
  };

  onClickUpdateToAllOutlets = e => {
    const { dispatch } = this.props;
    dispatch(actItem.showUpdateToAllOutletsModal());
    e.preventDefault();
    e.stopPropagation();
  };

  onCancelUpdateToAllOutletsModal = () => {
    const { dispatch } = this.props;
    dispatch(actItem.hideUpdateToAllOutletsModal());
  };

  onConfirmModalErrorUpdateAllOutlet = () => {
    const { dispatch } = this.props;
    dispatch(actItem.hideErrorUpdateAllOutletModal());
  };

  onSubmitUpdateToAllOutlets = values => {
    const { dispatch } = this.props;
    if (
      ((values.is_reward_item ||
        values.is_point_gain_item ||
        values.is_point_gain_category_item ||
        values.is_reward_category_item) &&
        (this.props.itemDetail.name !== values.name ||
          this._isRewardItemVariantChanged(values))) ||
      this.props.itemDetail.categoryChangeMessage
    ) {
      dispatch(actItem.showUpdateModal());
    } else {
      this.onSubmitUpdateAllOutlet(values);
    }
  };

  _onClickCancel = e => {
    this.props.dispatch(actItem.onClickCancel());
    e.preventDefault();
    e.stopPropagation();
  };

  _onSubmitCreateAllOutlet = values => {
    this.props.onSubmit({ ...values, action: 'save_to_all_outlet' });
  };

  _onClickSave = item => {
    const { dispatch } = this.props;
    if (
      ((item.is_reward_item ||
        item.is_point_gain_item ||
        item.is_point_gain_category_item ||
        item.is_reward_category_item) &&
        (this.props.itemDetail.name !== item.name ||
          this._isRewardItemVariantChanged(item))) ||
      this.props.itemDetail.categoryChangeMessage
    ) {
      dispatch(actItem.showUpdateModal());
    } else {
      this._onSubmitSave(item);
    }
  };

  _isRewardItemVariantChanged = item => {
    const currentVariants = item.item_variants.map(variant => variant.name);
    let variants = this.props.itemDetail.item_variants;
    let rewardItemVariantChanged = false;
    variants = variants.filter(function(el) {
      return (
        el.is_reward_item_variant === true ||
        el.is_point_gain_item_variant === true
      );
    });
    variants = variants.map(variant => variant.name);
    variants.forEach(variant => {
      if (currentVariants.indexOf(variant) === -1) {
        rewardItemVariantChanged = true;
      }
    });
    return rewardItemVariantChanged;
  };

  _onSubmitSave = values => {
    this.props.onSubmit({ ...values, action: 'save' });
    this._onHideUpdateModal();
  };

  onSubmitUpdateAllOutlet = values => {
    const { dispatch } = this.props;
    dispatch(actItem.hideUpdateToAllOutletsModal());
    clevertapLibraryList.updateToAllOutletClicked(values.id, values.name);
    this.props.onSubmit({ ...values, action: 'save_to_all_outlet' });
  };

  _onChangeCategories = (val, newVal) => {
    if (this.props.itemDetail.id) {
      if (
        this.props.itemDetail.category.id !== newVal &&
        (this.props.itemDetail.is_point_gain_item ||
          this.props.itemDetail.is_reward_item ||
          this.props.itemDetail.is_point_gain_category_item ||
          this.props.itemDetail.is_reward_category_item)
      ) {
        this.props.itemDetail.categoryChangeMessage =
          "Changing this item's category will affect your loyalty program. Are you sure you want to do this?";
        this.props.itemDetail.categoryChangeTitle = 'Change Item Category';
      } else {
        this.props.itemDetail.categoryChangeMessage = '';
        this.props.itemDetail.categoryChangeTitle = '';
      }
    }
  };

  _isHaveSalesType = () => {
    const { salesType } = this.props;
    return salesType.length > 0;
  };

  _findUncategorized = categories => {
    let idUncategory = null;
    categories.map(function(category) {
      if (category.name === 'Uncategorized') {
        idUncategory = category.id;
      }
    });
    return idUncategory;
  };

  _onClickSalesType = () => {
    const { isDirtyForm } = this.props;
    if (isDirtyForm) {
      this.props.dispatch(askConfirmAction(actItem.onRedirectSalesType()));
    } else {
      this.props.dispatch(actItem.onRedirectSalesType());
    }
  };

  _onChangeSalesType = event => {
    const { itemForm } = this.props;
    if (event.target.checked) {
      itemForm.item_variants.map(itemVariant => {
        if (
          !itemVariant.sales_type_items ||
          itemVariant.sales_type_items.length === 0
        ) {
          itemVariant.sales_type_items = [];
          const itemVariantSalesTypeIdList = itemVariant.sales_type_items.map(
            sti => sti.sales_type_id
          );
          itemForm.sales_type.forEach(salesType => {
            if (itemVariantSalesTypeIdList.indexOf(salesType.id) === -1) {
              salesType.selected = true;
              itemVariant.sales_type_items.push({
                sales_type_id: salesType.id,
                sales_type_price: '',
                sales_type_name: salesType.name,
              });
            }
          });
        } else {
          const itemVariantSalesTypeIdList = itemVariant.sales_type_items.map(
            sti => sti.sales_type_id
          );
          itemForm.sales_type.forEach(salesType => {
            if (itemVariantSalesTypeIdList.indexOf(salesType.id) > -1) {
              salesType.selected = true;
            } else {
              itemVariant.sales_type_items.push({
                sales_type_id: salesType.id,
                sales_type_price: '',
              });
            }
          });
        }
      });
      this.props.dispatch(
        change('item', 'item_variants', itemForm.item_variants)
      );
    }
  };

  onCancelCreateNewBrand = () => {
    const { dispatch, previousBrand, previousBrandId } = this.props;
    dispatch(actItem.setBrandList(previousBrand));
    dispatch(change('item', 'brand_id', previousBrandId));
    dispatch(actItem.hideNewBrandModal());
  };

  onConfirmCreateBrandModal = () => {
    const { dispatch, newBrand, search } = this.props;
    dispatch(actItem.onConfirmCreateNewBrand(newBrand, search.outletIds[0]));
  };

  onConfirmNotifModal = () => {
    const { itemForm } = this.props;
    this.props.onSubmit({ ...itemForm, action: 'save' });
  };
}

ItemForm.propTypes = {
  onSubmit: PropTypes.func,
  dispatch: PropTypes.func,
  mokapayMode: PropTypes.bool,
  allowLongerDescription: PropTypes.bool,
};

ItemForm.defaultProps = {
  mokapayMode: false,
  allowLongerDescription: false,
};

function mapStateToProps(state) {
  const { item, salesType } = state.library;
  const {
    customCategoriesEcommerceFashion,
    customCategoriesEcommerceFashionData,
    isRetail,
  } = item;
  const {
    ingredientSubscription: { subscriptionDetail },
  } = state.ingredients;
  const { is_mokapos_user: isMokaposUser } = state.moka.user.business;
  return {
    isMokaposUser,
    isRetail,
    customCategoriesEcommerceFashion,
    customCategoriesEcommerceFashionData,
    ecommerceCategory: item.ecommerceCategory,
    outlets: item.outlets,
    modifiers: item.modifiers,
    itemDetail: item.itemDetail,
    itemForm: getFormValues('item')(state),
    categories: item.categories,
    showDeleteModal: item.showDeleteModal,
    showUpdateModal: item.showUpdateModal,
    showUpdateToAllOutletsModal: item.showUpdateToAllOutletsModal,
    showErrorUpdateAllOutletModal: item.showErrorUpdateAllOutletModal,
    items: item.items,
    showNewCategoryModal: item.showNewCategoryModal,
    showNewBrandModal: item.showNewBrandModal,
    newBrand: item.newBrand,
    newCategory: item.newCategory,
    previousBrand: item.previousBrand,
    previousBrandId: item.previousBrandId,
    previousCategories: item.previousCategories,
    previousCategoryId: item.previousCategoryId,
    isTrack: item.isTrack,
    mustScrollTop: item.mustScrollTop,
    isSubmittingForm: item.isSubmittingForm,
    isDirtyForm: isDirty('modal_item_variants')(state),
    search: getFormValues('search')(state),
    ingredientSubscriptionDetail: subscriptionDetail,
    salesType: salesType.salesType,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onUpgradeNowClick: () => dispatch(showUpgradeModal()),
  };
}

const mapForm = {
  form: 'item',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(ItemForm));

const mapFlagToProps = flags => {
  return {
    hasImproveNineDigitStock: flags.improvementNineDigitStock,
    allowLongerDescription: flags.improvementItemDescription,
    businessLibraryMenu: flags.businessLibraryMenu,
    ecommerceAttributes: flags.ecommerceAttributes,
    updateToAllOutlets: flags.updateToAllOutlets,
  };
};

export default withFeatureFlag(mapFlagToProps)(connected);
